import { Navigate } from 'react-router-dom';
import routes from 'constants/routes';

/**
 * Phase 0 Remove-bucket: SVA Wallet main / Withdraw To Bank / Basket Withdraw
 * are gone on the new backend. Keep routes registered but redirect away so
 * Freeze/Ready surfaces stay reachable without remounting Remove UX.
 */
export function RedirectRemovedWalletMain() {
    return <Navigate to={routes.wallet.givingBasket} replace />;
}

export function RedirectRemovedWithdrawToBank() {
    return <Navigate to={routes.wallet.parishWallet} replace />;
}

export function RedirectRemovedBasketWithdraw() {
    return <Navigate to={routes.home.main} replace />;
}

/**
 * Temporary: Portal Send Money UI entry points are hidden. Keep `/send-money`
 * registered and redirect so deep links cannot render the freeze page.
 * Re-enable by restoring the SendMoney route + UI CTAs (pages stay intact).
 */
export function RedirectTemporarilyHiddenSendMoney() {
    return <Navigate to={routes.home.main} replace />;
}
